import { parseLogicActionTarget, type LogicAction } from '../../..'
import * as next from '../../../types/next'
import type { UpLogicHandler } from '../types'

export const up: UpLogicHandler<next.JumpToStepLogic> = (
  action: LogicAction
): Omit<
  next.JumpToStepLogic,
  'id' | 'orderIndex' | 'triggeredOn' | 'conditions'
> => {
  return {
    action: next.LOGIC_ACTION.JUMP_TO_STEP,
    settings: {
      targetStep: upTargetStep(action)
    }
  }
}

const upTargetStep = (action: LogicAction): string => {
  const targetStepId = parseLogicActionTarget(action.target)

  if (!targetStepId) {
    throw new Error(`Target step is required in Jump to Step logic`)
  }

  return targetStepId
}
